/** Parse Prisma Decimal JSON ({ d: [...] }) or number to string. */
export function parsePrismaDecimal(val) {
  if (val == null || val === '') return '';
  if (typeof val === 'number') return String(val);
  if (typeof val === 'object' && val.d && Array.isArray(val.d)) {
    return String(val.d.join(''));
  }
  return String(val);
}
